


















import { Component, Vue, Prop } from "@/shared/vuepack";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap,
  HsabExpenseCategory,
  hsabExpenseCategoryMap,
  hsabExpenseOriginatorTypeMap,
  UnusedDistributionResponse,
} from "@/shared/types";
import moment from "moment";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { formatCurrency } from "@/shared/currency.js";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill
  }
})
export default class AccountHolderExpenseDistributionDetail extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;

  @Prop()
  unusedDistribution: UnusedDistributionResponse;


  get formattedDateOfService () {
    return moment(this.unusedDistribution.dateOfService).format("MMM DD, YYYY");
  }

  get formattedSubmittedDate () {
    return moment(this.unusedDistribution.dateOfService).format("MMM DD, YYYY");
  }

  get formattedOriginator () {
    if (this.unusedDistribution.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.unusedDistribution.originator];
    }
    return "Unknown";
  }

  get formattedCategory () {
    if (this.unusedDistribution.expenseCategory) {
      return this.hsabExpenseCategoryMap[this.unusedDistribution.expenseCategory];
    }
    return "Unknown";
  }

  get status (): CombinedClaimReceiptStatus {
    return this.unusedDistribution.status && this.unusedDistribution.status.length > 0 ?
        this.unusedDistribution.status[0] :
        CombinedClaimReceiptStatus.None;
  }

  get statusDisplayText () {
    return CombinedClaimReceiptStatusMap[this.status];
  }

  get showCategory () {
    return this.unusedDistribution.expenseCategory !== undefined
        && this.unusedDistribution.expenseCategory !== null
        && this.unusedDistribution.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showAmount () {
    return !isNullEmptyOrUndefined(this.unusedDistribution)
        && !isNullEmptyOrUndefined(this.unusedDistribution.amount);
  }

  get showProviderName () {
    return !isNullEmptyOrUndefined(this.unusedDistribution)
        && !isNullEmptyOrUndefined(this.unusedDistribution.displayText);
  }

  get showSource () {
    return !isNullEmptyOrUndefined(this.formattedOriginator);
  }

  get showDateOfExpense () {
    return !isNullEmptyOrUndefined(this.unusedDistribution)
        && !isNullEmptyOrUndefined(this.unusedDistribution.dateOfService);
  }

  get showStatus () {
    return !isNullEmptyOrUndefined(this.statusDisplayText);
  }
  get showPlanDisplay (): boolean {
    return this.unusedDistribution
      && this.unusedDistribution.planDisplayText
      && this.unusedDistribution.planDisplayText.length > 0;
  }
  get formattedPlanDisplay (): string {
    return this.unusedDistribution.planDisplayText.join(", ");
  }
  get showRecipients () {
    return this.unusedDistribution
      && this.unusedDistribution.recipients
      && this.unusedDistribution.recipients.length > 0;
  }
}
